import React, { useEffect, useState } from "react"
import Image from "next/image"
import { CloseIcon } from "components/SVG"
import type { VariantType } from "@shared/graphql.types"
import {
  activeShadeBorder,
  modalShadeSwatch,
  modalButton,
  modalSwatchWrapper,
  outOfStockIcon,
  modalShadeName,
  shadeSelectorContent,
} from "./ShadeSelectorModal.css"

type Props = {
  variant: VariantType
  styleVariant?: "default" | "scrollShadow"
  handleShadeSelection: (
    shade: VariantType,
    activeShade: VariantType | null,
    event:
      | React.KeyboardEvent<HTMLButtonElement>
      | React.MouseEvent<HTMLButtonElement>
  ) => void
}

export const ShadeSelectorModalContent: React.FC<Props> = ({
  variant,
  styleVariant = "default",
  handleShadeSelection,
}) => {
  const [activeShade, setActiveShade] = useState<VariantType | null>(null)

  useEffect(() => {
    setActiveShade(variant)
  }, [variant])

  if (!variant) return null

  return (
    <div className={shadeSelectorContent[styleVariant]}>
      {variant?.relatedVariants?.map((shade) => {
        if (!shade) return null
        const isOutOfStock = shade?.availability?.status === "outofstock"
        const isActiveShade = activeShade?.id === shade.id

        return (
          <button
            type="button"
            key={shade.id}
            tabIndex={0}
            onClick={(event) => handleShadeSelection(shade, activeShade, event)}
            onKeyDown={(event) =>
              handleShadeSelection(shade, activeShade, event)
            }
            className={`${modalButton.default} ${
              isActiveShade ? activeShadeBorder : ""
            }`}
            style={{ opacity: isOutOfStock ? 0.5 : 1 }}
          >
            <div className={modalSwatchWrapper}>
              {shade.shadeVisual && (
                <Image
                  src={shade?.shadeVisual}
                  alt={shade?.title}
                  height="45"
                  width="45"
                  className={modalShadeSwatch}
                />
              )}
              {isOutOfStock && (
                <CloseIcon width="20px" className={outOfStockIcon} />
              )}
            </div>
            <span className={modalShadeName}>{shade.subTitle}</span>
          </button>
        )
      })}
    </div>
  )
}
